export const DEEPLINKS = {
  CONSENT: "download-consent",
  SET_2FA: "set-2fa",
};

export const DEEPLINK_ID = {
  CONSENT: "profile-legal",
  SET_2FA: "profile-security",
};
